













































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import VerifyReservation from '@/components/VerifyReservation.vue';
import IdentityFields from '@/components/IdentityFields.vue';
import AddressFields from '@/components/AddressFields.vue';
import ContactInformationFields from '../components/ContactInformationFields.vue';
import IdentityVerificationFields from '../components/IdentityVerificationFields.vue';
import EmploymentAndIncomeFields from '../components/EmploymentAndIncomeFields.vue';
import AdditionalCardholderFields from '../components/AdditionalCardholderFields.vue';
import { ConsumerApplicationState, ConsumerApplicationStatus } from '../store/consumer-application/types';
import LandingPage from '../components/LandingPage.vue';
import { State,Getter } from 'vuex-class';
import { FinancialInstitutionState } from '@/store/financial-institution/types';
import { ProductInformationState } from '@/store/product-information/types';
import ProcessingModal from '@/components/ProcessingModal.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import ApplicationComplete from '@/components/ApplicationComplete.vue';
import ApplicationCompletionSubHeader from '@/components/ApplicationCompletionSubHeader.vue';
import LayoutFooter from '@/components/layout/LayoutFooter.vue';
import { DocumentRequest, BbvaDocumentState } from '../store/bbva-document/types';
import  ApplyNowSection  from '@/components/ApplyNowSection.vue';

const namespace = 'consumerApplication';

@Component({
	components: {
		'verify-reservation': VerifyReservation,
		'identity-fields': IdentityFields,
		'address-fields': AddressFields,
		'contact-information-fields': ContactInformationFields,
		'identity-verification-fields': IdentityVerificationFields,
		'employment-and-income-fields': EmploymentAndIncomeFields,
		'additional-cardholder-fields': AdditionalCardholderFields,
		'landing-page': LandingPage,
		'processing-modal': ProcessingModal,
		'progress-bar': ProgressBar,
		'application-complete': ApplicationComplete,
		'application-completion-sub-header': ApplicationCompletionSubHeader,
		'layout-footer': LayoutFooter,
		'apply-now-section': ApplyNowSection,
	},
})
export default class MainPage extends Vue {
	errorMessage = '';
	reservationCode = '';
	fiConfigurationDataLoaded = false;
	fiConfigurationData: any;
	fiLogoUrl = '';
	productInfoLoaded = false;
	productInfo: any;
	applicationStep = 0;
	isCash = false;
	bbvaPrefs ='';
	@State('consumerApplication') consumerApplication?: ConsumerApplicationState;
	@State('financialInstitution') financialInstitution!: FinancialInstitutionState;
	@State('productInformation') productInformation!: ProductInformationState;
	@State('bbvaDocument') bbvaDocument!: BbvaDocumentState;
	@Getter('processingStatus', { namespace }) processingStatus?: ConsumerApplicationStatus;


	mounted() {
		if (this.$route.params.tokenData && this.$route.params.tokenData.length > 0) {
			const tokenData = JSON.parse(this.$route.params.tokenData) || {};
			this.reservationCode = tokenData.externalId;

			this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_RESERVATION_CODE', this.reservationCode);
			this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_FI_ID', tokenData.fiId);

			const documentRequest: DocumentRequest = {
				financialInstitutionIdentifier: tokenData.fiId, 
				reservationCode: this.reservationCode,
			};
			this.$store.dispatch('bbvaDocument/fetchData', documentRequest);
			this.bbvaDocument.isLoaded = true;
			this.$store.dispatch('financialInstitution/fetchData', tokenData.fiId);
			this.financialInstitution.isLoaded = true;
			this.$store.dispatch('productInformation/fetchData', {fiId: tokenData.fiId, productShortname: this.$route.name});
			this.productInformation.isLoaded = true;
			if (this.$route.name === 'cash') {
				this.isCash = true;
			} else {
				this.isCash = false;
			}
		}
	}

	startApplication() {
		window.scrollTo(0,0);
		this.$emit('setIdleTimeoutActive', true);
		this.applicationStep = 1;
	}

	reservationCodeVerified() {
		window.scrollTo(0,0);
		this.applicationStep = 2;
	}

	@Watch('processingStatus')
	applicationComplete(){
		if(this.processingStatus == ConsumerApplicationStatus.PROCESSING){
			window.scrollTo(0,0);
			this.applicationStep = 3;
		}
		if(this.processingStatus == ConsumerApplicationStatus.UPGRADING){
			window.scrollTo(0,0);
			this.applicationStep = 4;
		}
	}

	data() {
		return {
			valid: false,
		};
	}
}
